<div class="modal-body pb-2">

  <div class="row" style="justify-content: center; padding-top: 10px;">
    <img src="assets/img/withdraw/incorrect.png" width = "50px" hegith = "50px">
  </div>

  <div class="row" style="justify-content: center; padding-top: 10px;" >
    <h3 class="text-danger text-center"  *ngIf="this.data.db_qFailCount == 3"> {{ forget_message_block1 }} </h3>
    <h3 class="text-danger text-center"  *ngIf="this.data.db_qFailCount != 3">      
      <span *ngIf="data.db_qFailCount == 1">1<sup>st</sup></span>
      <span *ngIf="data.db_qFailCount == 2">2<sup>nd</sup></span>{{ forget_message_title }}
    </h3>
  </div>

  <div class="row" *ngIf="this.data.db_qFailCount == 3">
    <ul>
      <li>{{ forget_message_block2 }}</li>
    </ul> 
  </div>

  <div class="row" *ngIf="this.data.db_qFailCount == 3">
    <div class="card" style="background-color: #89ffbd;color: #000;text-align: center;">
      <div class="card-body">
        {{ forget_message_block3 }}
      </div>
    </div>
  </div>

  <div class="row" *ngIf="this.data.db_qFailCount != 3">
    <ul>
      <li *ngFor="let desObj of description;">{{ desObj }}</li>
    </ul>   
  </div>

  <div class="row pt-2" style="justify-content: space-around;"  *ngIf="this.data.db_qFailCount == 3">    
    <button type="button" class="btn button-notRound" style="width: 125px; height: 40px; background: #ffcb50 !important;color: #000 !important; border-radius: 5px;"  (click)="goCustomerService()">{{customerBtnName}}</button>            
    <button type="button" class="btn button-notRound" style="width: 125px; height: 40px; background: #017078 !important;color: #fff !important; border-radius: 5px;"  (click)="goHome()">{{closeBtnName}}</button>            
  </div>

  <div class="row" style="justify-content: space-around;"  *ngIf="this.data.db_qFailCount != 3">    
    <button type="button" class="btn button-notRound" style="width: 92%; height: 40px; background: #017078 !important;color: #fff !important; border-radius: 5px;"  (click)="goWallet()">{{closeBtnName}}</button>
  </div>

</div>  